var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18L3 18C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16L17 16ZM6.29289 9.29289L13.2929 2.29289C13.6534 1.93241 14.2206 1.90468 14.6129 2.2097L14.7071 2.29289L17.7071 5.29289C18.0676 5.65338 18.0953 6.22061 17.7903 6.6129L17.7071 6.70711L10.7071 13.7071C10.5508 13.8634 10.3481 13.9626 10.1314 13.9913L10 14H7C6.48716 14 6.06449 13.614 6.00673 13.1166L6 13L6 10C6 9.77899 6.07316 9.56552 6.20608 9.39197L6.29289 9.29289L13.2929 2.29289L6.29289 9.29289ZM14 4.41421L8 10.4142L8 12H9.58579L15.5858 6L14 4.41421Z",
    fill: "#7256CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.eddbb51b0c58b47be492525b13e581ef.svg";
export { ForwardRef as ReactComponent };